import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'

interface LogoProps {
    href?: string
    className?: string
    inverted?: boolean
}

export const LogoMark: FC<{ className?: string }> = ({ className }): ReactNode => (
    <svg viewBox='0 0 64 64' className={cn('size-8 shrink-0', className)} aria-hidden='true'>
        <rect width='64' height='64' rx='16' fill='#1C1814' />
        <rect x='14' y='16' width='22' height='30' rx='5' fill='#FF6B4A' transform='rotate(-8 25 31)' />
        <rect x='27' y='16' width='22' height='30' rx='5' fill='#FBF8F3' />
        <rect x='31' y='22' width='14' height='3.5' rx='1.75' fill='#1C1814' />
        <rect x='31' y='28' width='10' height='3.5' rx='1.75' fill='#1C1814' />
    </svg>
)

export const Logo: FC<LogoProps> = ({ href = '/', className, inverted = false }): ReactNode => (
    <Link
        href={href}
        className={cn('inline-flex items-center gap-2.5 rounded-md font-heading text-xl font-bold tracking-tight', inverted ? 'text-paper' : 'text-foreground', className)}
        aria-label='Feedsmith home'
    >
        <LogoMark />
        <span>Feedsmith</span>
    </Link>
)
